export default __webpack_public_path__ + "static/media/YouPorn.6ef5b30f.jpg";